module.exports = __webpack_public_path__ + "static/img/defaultPhoto1.852f005.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defaultPhoto1.jpg
// module id = lWIJ
// module chunks = 2